import TemplateView from '../../../../../TemplateView'
import messageResource from '../../../../../messageResource'
import NumberFormatter from '../../../../../number_formatter'

export default class TransferContent extends TemplateView {
    constructor({
        withArrow = true,
        withAdditionalText = true,
    } = {}) {
        super()

        this.params = {
            withArrow,
            withAdditionalText,
        }

        this.state = {
            fee: 0,
            canPayByWireTransfer: true,
            minWireTransferAmount: 0,
        }

        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

        this.onAnyStatePropertyChanged(['fee', 'canPayByWireTransfer', 'minWireTransferAmount'], () => {
            this.$priceTitle.text(messageResource.getMessage('licenses.purchase.purchase_step.transfer.price_title', [this._getFormattedPrice(this.state.fee)]))

            this.$additionalTitle.text(messageResource.getMessage('licenses.purchase.purchase_step.transfer.additional_title'))

            this.$arrowImg.toggle(this.params.withArrow && this.state.canPayByWireTransfer)

            if(!this.state.canPayByWireTransfer) {
                this.$priceTitle.text(messageResource.getMessage('licenses.purchase.purchase_step.wire_transfer_disabled.title', [this._getFormattedPrice(this.state.minWireTransferAmount)]))
                this.$additionalTitle.text(messageResource.getMessage('licenses.purchase.purchase_step.wire_transfer_disabled.additional_title'))
            }
        })
    }

    templateHtml() {
        return '<div class="transfer">' +
               '    <div class="priceTitle"/>' +
               '    <div class="additionalTitle"/>' +
               '    <div class="arrowImg"/>' +
               '</div>'
    }

    afterRender() {
        this.$priceTitle = this.find('.priceTitle')
        this.$additionalTitle = this.find('.additionalTitle')
        this.$arrowImg = this.find('.arrowImg')
        this.$arrowImg.toggle(this.params.withArrow)
        this.find('.additionalTitle').toggle(this.params.withAdditionalText)

        this.renderInitialState()
    }

    _getFormattedPrice(priceInCents) {
        return this.numberFormatter.format(priceInCents / 100)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/paymentStep/TransferContent.js